<template>
  <div class="request-general-info-main-section mt-2">
    <div>
      <div class="row p-4">
        <div class="col-12 col-md-3">
          <validation-provider
            v-slot="{ errors }"
            name="requestDate"
            :rules="!isReadOnly && !value.requestId ? 'required' : ''"
          >
            <label class="data-title mb-0">Fecha de solicitud:</label>
            <span v-if="isReadOnly || value.requestId" class="data-content d-block">
              {{ model.requestDate | date }}
            </span>
            <custom-date-picker
              v-else
              v-model="model.requestDate"
              :class-container="'w-100'"
              :custom-error-msg="'La fecha de solicitud es requerida.'"
              :disabled="isReadOnly"
              :error="errors[0]"
              format="dd/MMM./yyyy"
              :max-date="maxDate"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-3">
          <validation-provider
            ref="applicantNameValueRef"
            v-slot="{ errors }"
            mode="passive"
            name="applicantNameValue"
            :rules="
              !model.unknownApplicantNameFlag && !isReadOnly ? 'required' : ''
            "
          >
            <label class="data-title mb-0">Nombre de quien solicita:</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ model.applicantName | empty }}
            </span>
            <input
              v-else
              class="form-control"
              :class="
                errors[0] && !model.unknownApplicantNameFlag
                  ? 'was-Invalidated'
                  : ''
              "
              data-vv-validate-on="submit"
              :disabled="model.unknownApplicantNameFlag || isReadOnly"
              :error="errors[0]"
              :required="!model.unknownApplicantNameFlag"
              :value="applicantNameValue"
              @input="onChangeApplicantName"
            />
            <error
              v-if="errors[0] && !model.unknownApplicantNameFlag"
              :message="'El nombre de quien solicita es requerido.'"
              variant="no-border"
            />
          </validation-provider>
          <check-box
            v-if="!isReadOnly"
            v-model="model.unknownApplicantNameFlag"
            :disabled="isReadOnly"
            text="Desconocido"
          />
        </div>
        <div class="col-12 col-md-3">
          <validation-provider
            v-slot="{ errors }"
            name="applicant"
            :rules="!isReadOnly ? 'required' : ''"
          >
            <label class="data-title mb-0">Solicitante:</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ model.applicantPositionName | empty }}
            </span>
            <custom-drop-down
              v-else
              v-model="applicantCategorySelected"
              custom-error-msg="El nombre del solicitante es requerido."
              :disabled="isReadOnly"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="applicantCategories"
              placeholder="Seleccione"
              @input="onChangeApplicantCategory"
            />
          </validation-provider>
        </div>
        <div v-if="!isApplicantFatherMotherOrManager" class="col-12 col-md-3">
          <validation-provider
            v-slot="{ errors }"
            name="personInChargeName"
            :rules="!isApplicantFatherMotherOrManager ? 'required' : ''"
          >
            <label class="data-title mb-0">Encargado:</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ model.personInChargeName | empty }}
            </span>
            <custom-input
              v-else
              v-model="model.personInChargeName"
              :custom-error-msg="'El nombre del encargado es requerido.'"
              :disabled="isReadOnly"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDatePicker from 'custom-date-picker';
import CustomDropDown from 'custom-drop-down';
import CheckBox from 'CheckBox';
import CustomInput from 'CustomInput';
import { ValidationProvider } from 'vee-validate';
import ApplicantCategories from '@/utils/constants/applicantCategories';
import Error from 'custom-error';
export default {
  name: 'RequestGeneralInfo',
  components: {
    CustomDatePicker,
    CustomInput,
    CheckBox,
    CustomDropDown,
    Error,
    ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    applicantCategories: {
      type: Array,
      required: true,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      maxDate: new Date(),
      applicantCategorySelected: null,
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.onValueChange(val);
      },
    },
    applicantNameValue() {
      return this.model.unknownApplicantNameFlag
        ? ''
        : this.model.applicantName;
    },
    isApplicantFatherMotherOrManager() {
      const isFatherOrMother = this.model.applicantPositionId === ApplicantCategories.FatherMotherOrManager
      if(isFatherOrMother) this.model.personInChargeName = null;
      return isFatherOrMother;
    },
    allowSetApplicantAsManager() {
      return (
        !this.isApplicantFatherMotherOrManager && !this.model.personInChargeName
      );
    },
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal.applicantPositionId && newVal.applicantPositionName) {
          this.applicantCategorySelected = {
            id: this.value.applicantPositionId,
            name: this.value.applicantPositionName,
          };
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeApplicantName(event) {
      this.model.applicantName = event.target.value;
    },
    onChangeApplicantCategory(item) {
      this.model.applicantPositionId = item ? item.id : null;

      if (this.allowSetApplicantAsManager) {
        this.model.personInChargeName = this.model.applicantName;
      }
      this.$refs.applicantNameValueRef.reset();
    },
    onValueChange(val) {
      let resultObj = { ...val };
      if (this.isApplicantFatherMotherOrManager)
        resultObj.personInChargeName = null;
      if (resultObj.unknownApplicantNameFlag) resultObj.applicantName = null;
      this.$emit('input', resultObj);
    },
  },
};
</script>
